module.exports = __webpack_public_path__ + "static/media/single_product_screen_shot.2b996fc2.png";